export default __webpack_public_path__ + "static/mobile-app-statrys-logo-9ab2aace8bea22462f47d45adf7fdb31.png";